// Нижний HUD под стеком уведомлений (стек — в левом нижнем углу): угловые
// кнопки чата, реакций и слоев поля, их развернутые панели и футер. Такие
// элементы помечены этим атрибутом (Footer, ChatPanel, ReactionsPanel,
// VisualToggles)
export const TOASTS_AVOID_ATTRIBUTE = 'data-toasts-avoid';

// Зазор между стеком и нижним HUD
export const TOASTS_BOTTOM_GAP_PX = 10;

/**
 * Отступ стека уведомлений от низа окна: над самым высоким из помеченных
 * элементов, которые лежат под стеком по горизонтали (span), с зазором.
 * Пустые (скрытые), ушедшие за окно и лежащие в стороне от стека элементы не
 * в счет — футер на десктопе обычно правее стека, кнопка хода на телефоне
 * правее его края. Не выше половины окна — развернутая панель не выгоняет
 * стек за верх
 *
 * @param {Array<{top: number, bottom: number, left: number, right: number, width: number, height: number}>} rects
 * @param {number} viewportHeight
 * @param {{left: number, right: number}} span — горизонталь стека
 * @returns {number} CSS-пиксели, целые
 */
export const calcToastsBottomEdge = (rects, viewportHeight, span) => {
  let highestTop = viewportHeight;
  (rects || []).forEach((rect) => {
    if (!rect || !(rect.width > 0) || !(rect.height > 0)) {
      return;
    }
    if (rect.bottom <= 0 || rect.top >= viewportHeight) {
      return;
    }
    if (span && (rect.right <= span.left || rect.left >= span.right)) {
      return;
    }
    highestTop = Math.min(highestTop, rect.top);
  });
  const edge = viewportHeight - highestTop + TOASTS_BOTTOM_GAP_PX;
  return Math.round(Math.min(edge, viewportHeight / 2));
};
